import { useMutation } from '@tanstack/react-query';
import { translateNaturalLanguage } from '../api/analyticsApi';
import { useAnalyticsStore } from '../stores/analyticsStore';

export function useNaturalLanguageQuery() {
  const { setUIState, setCurrentQuery, setError } = useAnalyticsStore();

  return useMutation({
    mutationFn: async (query: string) => {
      setUIState('translating');
      setError(null);
      const response = await translateNaturalLanguage(query);
      return response;
    },
    onSuccess: (data) => {
      setCurrentQuery(data.interpretedQuery);
      setUIState('confirming');

      if (data.clarificationNeeded) {
        setError(data.clarificationNeeded);
      }
    },
    onError: (error) => {
      setError(error instanceof Error ? error.message : 'Failed to interpret query');
      setUIState('idle');
    },
  });
}
